export default {
      id: "activity-flag-usage",
      viewBox: "0 0 11 16",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#activity-flag",
      toString: function () {
        return this.url;
      }
    }